import client from './client';
import { Review, ReviewsResult, ReviewStats, ReviewStatus } from '../types/review';

export interface ReviewParams {
  status?: ReviewStatus | 'all';
  productId?: string;
  /** Inclusive date bounds, YYYY-MM-DD. */
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

const EMPTY_STATS: ReviewStats = { pending: 0, approved: 0, rejected: 0, total: 0 };

export async function getReviews(params: ReviewParams = {}): Promise<ReviewsResult> {
  const limit = params.limit ?? 20;
  const page = params.page ?? 1;

  const query: Record<string, string | number> = { limit, offset: (page - 1) * limit };
  if (params.status && params.status !== 'all') query.status = params.status;
  if (params.productId) query.product_id = params.productId;
  if (params.from) query.from = params.from;
  if (params.to) query.to = params.to;

  const res = await client.get('/api/admin/reviews', { params: query });
  const data = res.data ?? {};
  const reviews: Review[] = Array.isArray(data.reviews) ? data.reviews : [];

  return {
    reviews,
    total: data.total ?? reviews.length,
    stats: data.stats ?? EMPTY_STATS,
  };
}

/** Pending count for the sidebar badge. Never throws — a badge is not worth an
 *  error banner, so a failed poll simply leaves the previous number in place. */
export async function getPendingCount(): Promise<number> {
  try {
    const res = await client.get('/api/admin/reviews/pending/count');
    return Number(res.data?.count) || 0;
  } catch {
    return 0;
  }
}

export async function approveReview(id: string): Promise<void> {
  await client.put(`/api/admin/reviews/${id}/approve`);
}

export async function rejectReview(id: string): Promise<void> {
  await client.put(`/api/admin/reviews/${id}/reject`);
}

export async function deleteReview(id: string): Promise<void> {
  await client.delete(`/api/admin/reviews/${id}`);
}
